import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { CreditAccountListStore } from "../../store/CreditAccountListStore";

type CreditAccountListDialogsProps = {
  store: CreditAccountListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de CreditAccount.
 * Separado para mantener CreditAccountListPage más limpio.
 */
export const CreditAccountListDialogs: React.FC<CreditAccountListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
